namespace $.$$ {
	$mol_style_define($bog_blitz_admin_editor, {
		maxWidth: '50rem',
		align: {
			self: 'center',
		},
		width: '100%',
		gap: '1rem',
		padding: {
			top: '0.5rem',
			bottom: '1rem',
			left: '1rem',
			right: '1rem',
		},
		Title_input: {
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: '0.5rem',
			},
		},
		Settings: {
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: '0.5rem',
			},
			padding: {
				top: '0.5rem',
				bottom: '0.5rem',
				left: '0.75rem',
				right: '0.75rem',
			},
			flexDirection: 'row',
			flexWrap: 'wrap',
			gap: '0.5rem',
		},
		Add_question: {
			align: {
				self: 'flex-start',
			},
			border: {
				radius: '0.5rem',
			},
		},
	})
}
